import THEME from 'pobble-components/dist/theme'

const { COLORS, FONT_SIZES } = THEME

export default {
  menu: {
    ...FONT_SIZES.BODY_DEFAULT.STYLE,
    padding: '10px 0',
    margin: '0',
    listStyle: 'none',
    textAlign: 'left',
    color: COLORS.TEXT.LIGHT_GREY.NORMAL
  }
}
